import { jsx as t } from "react/jsx-runtime";
const o = {
  "carousel-item": "_carousel-item_122pc_29"
};
function c({ children: e, style: s }) {
  return /* @__PURE__ */ t("li", { className: o["carousel-item"], style: s, children: e });
}
export {
  c as CarouselItem
};
